module.exports = __webpack_public_path__ + "static/img/14.f25f505.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/zh/14.png
// module id = cdNG
// module chunks = 0